module.exports = __webpack_public_path__ + "static/media/QA.b1303a15.svg";